// extracted by mini-css-extract-plugin
module.exports = {"button":"AppPage-styles-module--button--2cxO3","avatar":"AppPage-styles-module--avatar--VJmPZ","arrow":"AppPage-styles-module--arrow--27wHT"};